import { useState } from "react";
import {
  GetModalDevicesTabDetailsProcess,
  GetProcessesPerformanceDetailsProcess,
  GetProcessesPerformanceResponse,
} from "../../client/AuthedClient";
import { useAuthedClient } from "../../context/AuthedClientContext";
import { useFilters } from "../../context/FiltersContext";
import {
  ApplicationPerformanceSummaryCard,
  ApplicationPerformanceTable,
} from "./";
import "./ApplicationsPerformance.css";
export const ApplicationsPerformanceBody = (props: {
  processes: GetProcessesPerformanceResponse;
}) => {
  type DetailsState = Array<GetProcessesPerformanceDetailsProcess>;
  type DevicesDetailsState = Array<GetModalDevicesTabDetailsProcess>;
  const { processes } = props;
  const excludedBrowsers = [
    "google chrome",
    "chrome",
    "firefox",
    "microsoft edge",
    "safari",
    "brave browser",
    "brave",
    "tor",
    "apple safari",
    "opera",
    "chromium",
    "epic",
  ];

  const filteredProcesses = processes.filter((item: any) => {
    const { processName } = item;
    const processNametoLowerCase = processName?.toLowerCase();
    return !excludedBrowsers.includes(processNametoLowerCase);
  });
  //sort the data to create the top 3 and lowest 3 compliance app
  // we sort based on the availability percentage and the duration
  const sortBasedOnAvailability = (
    a: {
      totalCount: number;
      failureCount: number;
      totalDurationInSeconds: number;
    },
    b: {
      totalCount: number;
      failureCount: number;
      totalDurationInSeconds: number;
    }
  ) => {
    const availabilityA = (1 - a.failureCount / a.totalCount) * 100;
    const availabilityB = (1 - b.failureCount / b.totalCount) * 100;

    return availabilityB - availabilityA;
  };
  filteredProcesses.sort(
    (a, b) => b.totalDurationInSeconds - a.totalDurationInSeconds
  );

  filteredProcesses.sort((a, b) => sortBasedOnAvailability(a, b));

  const topProcesses = filteredProcesses
    .slice(0, 3)
    //.sort((a, b) => b.totalDurationInSeconds - a.totalDurationInSeconds)
    .sort((a, b) => sortBasedOnAvailability(a, b));

  const lowProcesses = filteredProcesses
    .slice(filteredProcesses.length - 3)
    // .sort((a, b) => b.totalDurationInSeconds - a.totalDurationInSeconds)
    .sort((a, b) => sortBasedOnAvailability(a, b))
    .reverse();

  const [showModal, setShowModal] = useState(false);
  const [modalTitle, setModalTitle] = useState("");
  const [details, setDetails] = useState<DetailsState>([]);
  const [devicesDetails, setDevicesDetails] = useState<DevicesDetailsState>([]);
  const filters = useFilters();
  const { startDate, endDate, group, user } = filters;
  const authedClient = useAuthedClient();
  const handleModalData = (proccessName: string) => {
    authedClient
      .getFailureDetails(proccessName, startDate, endDate, group, user)
      .then((res) => {
        setDetails(res);
        setTimeout(() => {
          setShowModal(true);
        }, 1000);
      });
  };
  const handleDevicesModalData = (processName: string) => {
    authedClient
      .getDevicesDetails(processName, startDate, endDate, group, user)
      .then((response) => setDevicesDetails(response));
  };
  const onDetailsClick = (processName: string) => {
    handleModalData(processName);
    handleDevicesModalData(processName);
    setModalTitle(processName);
  };
  return (
    <>
      <div className="row widgets g-4">
        <ApplicationPerformanceSummaryCard
          topProcesses={topProcesses}
          lowProcesses={lowProcesses}
          onDetailsClick={onDetailsClick}
        />
      </div>
      <div className="white-box m-0">
        <div className="row">
          <div className="col-lg-12">
            <ApplicationPerformanceTable
              processes={processes}
              showModal={showModal}
              onHide={() => setShowModal(false)}
              modalTitle={modalTitle}
              details={details}
              devicesDetails={devicesDetails}
              onDetailsClick={onDetailsClick}
            />
          </div>
        </div>
      </div>
    </>
  );
};
